import * as ko from "knockout";

// Models
import { PopoverOptionOverrides } from "Content/ts/Models/Bootstrap/TooltipsPopovers/popoverConfiguration";

// Services
import { FontAwesomeServices } from "Content/ts/Shared/KnockoutBindings/Services/fontAwesomeServices";

export namespace PopoverServices {
    export function RenderPopoverTemplate(allbindings: PopoverOptionOverrides): string {
        const container = "";

        ko.renderTemplate(allbindings.PopoverTemplate.Identifier, allbindings.PopoverTemplate.Data, { templateEngine: new ko.nativeTemplateEngine() }, container);

        return container;
    }

    export function BasePopoverTemplate(allbindings: PopoverOptionOverrides): string {
        return `
            <div class="popover" role="tooltip">
                <div class="arrow"></div>
                <h3 class="popover-title">${allbindings.Title}</h3>
                <div class="popover-content"></div>
            </div>
        `;
    }

    export function InformationIconMarkup(value: string | KnockoutObservable<string>): string {
        return `
            <div class="sr-only">${ko.unwrap(value)}</div>
            ${FontAwesomeServices.InfoCircleTooltip()}
        `;
    }
}
